import { AuthApi } from './auth/auth.api';
import { ChatApi } from './chat/chat.api';
import { PortfolioApi } from './portfolio/portfolio.api';
import { TradingApi } from './trading/trading.api';
import { PaymentsApi } from './payments/payments.api';
import { AdminApi } from './admin/admin.api';

const api = {
  auth: new AuthApi(),
  chat: new ChatApi(),
  portfolio: new PortfolioApi(),
  trading: new TradingApi(),
  payments: new PaymentsApi(),
  admin: new AdminApi(),
};

export default api;
